module.exports = __webpack_public_path__ + "img/GS.9a43acce.png";